import { MarketMessagePreSwitchEanDataRequestQueryStringParams, MarketMessagePreSwitchEanDataResponseBody } from '@boltenergy-be/shared'
import { stringify } from 'qs'
import dayjs from 'dayjs'
import { Methods, Response } from 'types/request.ts'
import { getAxiosRequestConfigBoltBackend, newRequest } from 'utils/request.ts'
import { log } from 'utils/logging.ts'
import { Flow } from 'types/logging.ts'

export const getEanData = async ({
  ean,
  energyType,
  contractStartDate
}: MarketMessagePreSwitchEanDataRequestQueryStringParams): Promise<Response<MarketMessagePreSwitchEanDataResponseBody>> => {
  try {
    const query = stringify(
      { ean, energyType, contractStartDate: contractStartDate ? dayjs(contractStartDate).format('YYYY-MM-DD') : null },
      { skipNulls: true }
    )
    const res = await newRequest<MarketMessagePreSwitchEanDataResponseBody>(
      getAxiosRequestConfigBoltBackend(Methods.GET, `/utilities/market-message/pre-switch/ean-data?${query}`)
    )

    if (!res.success) {
      log({
        error: res?.message || `unknown error with getEanData for ${ean}`,
        identifier: `[${Flow.CONTRACT}:getEanData${res?.errorCode ? `:${res.errorCode}` : ''}]`,
        errorCode: res?.errorCode
      })
    }

    return res
  } catch (error) {
    log({
      error: error instanceof Error ? error : 'Unknown error in getEanData',
      identifier: `[${Flow.CONTRACT}:CATCH:getEanData]`
    })

    return { success: false }
  }
}
